import React, { FC } from "react";

interface InformDescriptionProps {
    description: string;
    label: string;
}

const InformDescription: FC<InformDescriptionProps> = ({
    description,
    label,
}) => {
    return (
        <>
            {description && (
                <div className="comparison-card">
                    <div className="comparison-card__title">{label}</div>

                    <div className="comparison-description__container">
                        <div className="comparison-description">
                            {description}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default InformDescription;
